import jQuery, { dequeue } from 'jquery'

window.jQuery = window.$ = jQuery

import 'foundation-sites/js/entries/foundation'
import 'foundation-sites/js/entries/foundation-plugins'

import PubSub from 'pubsub-js'
import swal from 'sweetalert'
import LazyLoad from 'vanilla-lazyload'


// Vendors Config
const slick = require('./vendors/slick')
const autocomplete = require('./vendors/autocomplete')
const magnify = require('./vendors/magnify')
require('air-datepicker/dist/js/datepicker.min.js')
require('air-datepicker/dist/js/i18n/datepicker.en.js')
require('select2')
require('./components/GoogleMaps')

import tippy from 'tippy.js'

//import select2 from 'select2';

// Custom Components
import ResponsiveComponentToggler from './components/ResponsiveComponentToggler'
import LimitedList from './components/LimitedList'
import ResponsiveSidebar from './components/ResponsiveSidebar'
import ProductFilters from './components/ProductFilters'
import ResponsiveNav from './components/ResponsiveNav'
import BeforeLeave from './components/BeforeLeave'
import Sortable from './components/Sortable'
import ImageUploader from './components/ImageUploader'
import DragAndDropUploader from './components/DragAndDropUploader'
import Cart from './components/Cart'
import Curtain from './components/Curtain'
import Collections from './components/Collections'
import Helper from './components/Helper'
import NotificationsCenter from './components/NotificationsCenter'
import CollectionLoad from './components/CollectionLoad'
import { CommonListeners } from './CommonListeners'

//import jQueryUI from 'jquery-ui';

// Load Events
jQuery(document).ready(($) => {
    let myLazyLoad = new LazyLoad({
        elements_selector: '.lazyload',
    })
    // After your content has changed...
    myLazyLoad.update()


    const waitToShow = $('.waitToShow')
    if (waitToShow.length) $(waitToShow).removeClass('waitToShow')




    //init foundation
    $(document).foundation()


    CommonListeners();

    //Abide Validation
    $(document).on('formvalid.zf.abide', function (event, frm) {
        //console.log("Form id " + frm.attr('id') + " is valid");
        // form valid. Return event or set Ajax.
        return event
    })


    $('*[data-tabs]').on('change.zf.tabs', function (event) {
        $('.sticky-container').removeAttr('style')
        $('.sticky').addClass('is-anchored is-at-top').removeClass('is-stuck is-at-bottom')
    })


    //avoid data-open to submit a form
    $('*[data-tab-change]').on('click', (event) => {
        event.preventDefault()
        let component = $(`${$(event.target).data('tab-target')}`)
        let formElement = $(event.target).closest('form#product-form')
        if (formElement.length) {
            formElement = formElement[0]
            if (!formElement.checkValidity()) {
                formElement.reportValidity()
            } else {
                let tab = component.find(
                    `li > a[href="${$(event.target).data('tab-change')}"]`
                )
                $(tab).trigger('click')
                $('html, body').animate({ scrollTop: 0 }, 400)
            }
        } else {
            let tab = component.find(
                `li > a[href="${$(event.target).data('tab-change')}"]`
            )
            $(tab).trigger('click')
            $('html, body').animate({ scrollTop: 0 }, 400)
        }
    })

    $('*[data-responsive-src]').each((i, element) => {

      console.log(screen.width)
        let url = APP_CFG.imageResponsive
          .replace(/\-\-path/g, $(element).data('responsive-src'))
          .replace(/\-\-width/g, screen.width)

        $(element).attr('src', url);
    });

    $('.impose-number').on('change', (e) => {

        let el = $(e.target);

        if (el.val() == "") {
            return;
        }
        if (el.attr('min') && parseInt(el.val()) < parseInt(el.attr('min'))) {
            el.val(el.attr('min'));
        }

        if (el.attr('max') && parseInt(el.val()) > parseInt(el.attr('max'))) {
            el.val(el.attr('max'));
        }
    })


    // Fix foundation sticky
    const stickyToFix = $('*[data-sticky-on]')
    const checkSticky = (elemments) => {
        $(elemments).each((index, el) => {
            const on = $(el).data('sticky-on')
            if (Foundation.MediaQuery.atLeast(on)) {
                const elem = new Foundation.Sticky($(el))
            } else {
                // simple _destroy
                $(el).foundation('_removeSticky')
                $(el).removeClass('sticky is-anchored is-at-top').css({
                    height: '',
                    top: '',
                    bottom: '',
                    'max-width': '',
                }).off('resizeme.zf.trigger').off('mutateme.zf.trigger')

                $(el).parent('.sticky-container').removeClass('.sticky-container').css({ height: '' })
            }
        })
    }
    if (stickyToFix.length) {
        checkSticky(stickyToFix)

        $(window).on('changed.zf.mediaquery', (event) => {
            checkSticky(stickyToFix)
        })
    }

    //data-reducetext
    // const reducetexts = $('*[data-reducetext]');
    // if (reducetexts.length) {
    //   reducetexts.each((index, reducetext) => {
    //     let reducetextData = $(reducetext).data('reducetext');
    //     if (reducetextData == '') {
    //       reducetextData = 'medium';
    //     }
    //
    //     let wordLimit = 19;
    //     let original = $(reducetext).text();
    //     let exerpt = original.split(' ').filter( (word, index) => (index <= wordLimit) ? word : false).join(' ');
    //
    //     let bt = `<button class="link">Read more...</button>`;
    //
    //     console.log(exerpt);
    //     $(reducetext).on('click', '.link', (event) => {
    //       event.preventDefault();
    //       console.log('olá');
    //     });
    //
    //     $(window).on('load changed.zf.mediaquery', (event) => {
    //       if (Foundation.MediaQuery.atLeast(reducetextData)) {
    //         console.log('long text');
    //         $(reducetext).replaceWith(original);
    //       } else {
    //         console.log('short text');
    //         $(reducetext).replaceWith(`<p>${exerpt} ${bt}</p>`);
    //       }
    //     });
    //   });
    // }

    //data-hidder
    let hidders = $('*[data-hidder]')
    if (hidders.length) {
        const checkHidder = (hidder) => {
            const minimumBreakpoint = $(hidder).data('hidder')
            if (Foundation.MediaQuery.is(minimumBreakpoint)) {
                if (!$(hidder).is('.hide')) $(hidder).addClass('hide')
            } else {
                $(hidder).removeClass('hide')
            }
        }

        hidders.each((index, hidder) => {
            checkHidder(hidder)

            $(window).on('changed.zf.mediaquery', (event) => {
                checkHidder(hidder)
            })
        })
    }

    //radio toogle
    let radioToggles = $('*[data-radio-toggle]')
    if (radioToggles.length) {
        function toggleClass(trigger, target, cssClass, invert) {

            let condition = $(trigger).is(':checked');

            if (invert) {
                condition = !condition;
            }

            if (condition) {
                $(target).removeClass(cssClass)

                if (cssClass == 'hide') {
                    $(target).find('[_required]').each((index, node) => {
                        $(node).removeAttr("_required");
                        $(node).attr("required", "");
                    })
                }

            } else {
                $(target).addClass(cssClass)

                if (cssClass == 'hide') {
                    $(target).find('[required]').each((index, node) => {
                        $(node).removeAttr("required");
                        $(node).attr("_required", "");
                    });
                }
            }
        }

        radioToggles.each((index, radioToggle) => {
            let data = $(radioToggle).data('radio-toggle').split(',')
            let trigger = data[0],
                targets = data[1]

            $(targets).each((i, target) => {

                let cssClass = $(target).data('toggler')
                let invert = typeof $(target).data('toggler-invert') !== 'undefined'

                toggleClass(trigger, target, cssClass, invert)

                $(radioToggles).on('change', (event) => {
                    toggleClass(trigger, target, cssClass, invert)
                })
            })
        })
    }

    // ResponsiveSidebar > toggle content position
    const sidebar = $('*[data-responsive-sidebar]').first()
    if (sidebar.length) {
        let responsiveSidebar = new ResponsiveSidebar(sidebar)
        let filters = { started: false }

        function loadSidebar() {
            // console.log('loadSidebar()');
            let lists = new LimitedList($('.l-sidebar *[data-limited-list]'))
            $('#filters_menu').foundation('close')

            if (filters.started) {
                filters.destroy((cb) => {
                    filters = new ProductFilters()
                })
            } else {
                filters = new ProductFilters()
            }
        }

        PubSub.subscribe('ResponsiveSidebar_changed', (msg, data) => {
            loadSidebar()

            $('.l-sidebar').foundation()
        })
    }

    const extraServices = $('*[data-extra_service]').first()
    if (extraServices.length) {
        $('*[data-extra_service]').click((evt) => {
            let button = $(evt.target)
            $.ajax({
                url: button.data().action_url,
                dataType: 'JSON',
                method: 'POST',
                data: {
                    'transaction_id': button.data().transaction,
                    'option_id': button.data().extra_service_option,
                },
                success: function (data) {
                    var cardButton = document.getElementById('card-button')
                    cardButton.dataset.secret = data.pi_secret
                    $('#card-button').data().secret = data.pi_secret
                    $('#service_' + data.service.id).text('€ ' + data.service.price)
                    $('#cart-total').text('€ ' + data.totalWithDeliveryAmount)
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
            })
        })
    }

    const cartButton = $('*[data-add_to_cart]').first()
    if (cartButton.length) {
        $('*[data-add_to_cart]').click((evt) => {
            if (!platformEnvironmentVars.isLogged) {
                const modalRegister = $('#modal_register')
                modalRegister.find('#continue_as_guest').addClass('hide')
                if (modalRegister) $(modalRegister).foundation('open')
                return
            }
            let button = $(evt.target)
            if ($('input[name=\'delivery\']:checked').val() === undefined) {
                swal(
                    'Attention',
                    translations.select_at_least_a_delivery_method,
                    'warning'
                )
                return
            }

            if (!platformEnvironmentVars.isLogged) {
                const modalRegister = $('#modal_register')
                modalRegister.find('#continue_as_guest').removeClass('hide')
                if (modalRegister) $(modalRegister).foundation('open')
                return
            }

            if (
                $('input[name=\'delivery\']:checked').val().indexOf('delivery') >=
                0 &&
                $('select[name=\'shipping_address\']').val() === undefined
            ) {
                swal(
                    'Attention',
                    'Please, Select a shipping address',
                    'warning'
                )
                return
            }
            // if ($("input[name='delivery']:checked").val().indexOf("pickup") === -1 && $("select[name='shipping_address']").length > 0 && !$("select[name='shipping_address'] option:selected").data("country").toLowerCase().startsWith("ita")) {
            //   swal('Attention', 'The shipping selected is available only for shippings to Italy', 'warning');
            //   return;
            // }
            let actionUrl = button.data('action_url')

            let parameters = {}
            parameters.quantity = $('*[data-quantity]').first().length
                ? $('*[data-quantity]').first().val()
                : 1
            parameters.shipping = $('input[name=\'delivery\']:checked').val()
            parameters.shipping_group = $(
                'input[name=\'delivery\']:checked'
            ).data('group')
            parameters.shipping_address = $(
                'select[name=\'shipping_address\']'
            ).val()
            let cart = new Cart()
            cart._handleItem(actionUrl, parameters)
        })
    }

    // const selectedPickup = $("*[data-selected_pickup]").first();
    // if (selectedPickup.length) {
    //     selectedPickup.on('change', (evt) => {
    //         let radioButton = $(evt.target);
    //         if (radioButton.is(":checked")) {
    //             $(".make_an_offer, .add_to_cart").removeClass("hide");
    //         }

    //     });

    // }

    const deliverySelection = $('input[name=\'delivery\']')
    if (deliverySelection.length) {
        $('input[name=\'delivery\']').on('change', (evt) => {
            // if($("#tier_italy").data("amount") !== undefined) {
            //     return;
            // }
            if ($('input[name=\'delivery\']:checked').val().indexOf('pickup') >= 0) {
                $('.make_an_offer, .add_to_cart').removeClass('hide')
                console.log('show buttons 1')
            } else {
                if ($(evt.target).attr('id').startsWith('self_delivery')) {
                    $('.make_an_offer, .add_to_cart').removeClass('hide')
                    console.log('show buttons 1')
                } else { // intondo delivery
                  console.log("no shippings available");
                    // if ($('#shipping_amount_container').text() == '') {
                    //     $('.make_an_offer, .add_to_cart').addClass('hide')
                    //     console.log('hide buttons 2')
                    // } else {
                    //     $('.make_an_offer, .add_to_cart').removeClass('hide')
                    //     console.log('show buttons 2')
                    // }
                }

            }
        })
    }

    const shippingSelect = $('#shipping_address')
    if (shippingSelect.length) {

        shippingSelect.on('change', (evt) => {

            $('.shipping_options').addClass('hide')
            $('.make_an_offer, .add_to_cart').removeClass('hide')
            $('#shipping_amount_container').text('')
            $('.shipping_option_radio').prop('checked', false)

            let shippingObject = $(evt.target)
            let externalQuotation = null
            if (shippingSelect.data().volume <= (90 * 90 * 90)) {
                $.ajax({
                    url: '/api/shippings/get-quotation',
                    async: false,
                    data: { 'address_id': shippingObject.val(), 'product_id': shippingSelect.data().product_id },
                    success: function (data) {
                        if (data.found) {
                            if (data.amount > 0) {
                                externalQuotation = data.amount
                            }
                        }
                    }
                })
            }
            console.log(externalQuotation);
            if ((externalQuotation != null && externalQuotation < $('#tier_italy').data('amount')) || (externalQuotation != null && $('select[name=\'shipping_address\'] option:selected').data('iseu') == '0')) {
                console.log("external");
                $('#shipping_amount_container').text('€ ' + externalQuotation)
            } else {
                let destination = $('select[name=\'shipping_address\'] option:selected').data('country');
                destination = destination.toLowerCase() == "Italia".toLowerCase() ? "Italy" : destination;
                destination = destination.toLowerCase() == "Francia".toLowerCase() ? "France" : destination;
                destination = destination.toLowerCase() == "Belgio".toLowerCase() ? "Belgium" : destination;
                destination = destination.toLowerCase() == "Lettonia".toLowerCase() ? "Latva" : destination;
                destination = destination.toLowerCase() == "Lituania".toLowerCase() ? "Lithuania" : destination;
                destination = destination.toLowerCase() == "Croazia".toLowerCase() ? "Croatia" : destination;
                destination = destination.toLowerCase() == "Lussemburgo".toLowerCase() ? "Luxembourg" : destination;
                destination = destination.toLowerCase() == "Cipro".toLowerCase() ? "Cyprus" : destination;
                destination = destination.toLowerCase() == "Olanda".toLowerCase() ? "Netherlands" : destination;
                destination = destination.toLowerCase() == "Danimarca".toLowerCase() ? "Denmark" : destination;
                destination = destination.toLowerCase() == "Polonia".toLowerCase() ? "Poland" : destination;
                destination = destination.toLowerCase() == "Portogallo".toLowerCase() ? "Portugal" : destination;
                destination = destination.toLowerCase() == "Finlandia".toLowerCase() ? "Finland" : destination;
                destination = destination.toLowerCase() == "Slovacchia".toLowerCase() ? "Slovakia" : destination;
                destination = destination.toLowerCase() == "Germania".toLowerCase() ? "Germany" : destination;
                destination = destination.toLowerCase() == "Grecia".toLowerCase() ? "Greece" : destination;
                destination = destination.toLowerCase() == "Spagna".toLowerCase() ? "Spain" : destination;
                destination = destination.toLowerCase() == "Ungheria".toLowerCase() ? "Hungary" : destination;
                destination = destination.toLowerCase() == "Svezia".toLowerCase() ? "Sweden" : destination;
                destination = destination.toLowerCase() == "Irlanda".toLowerCase() ? "Ireland" : destination;

                let source = $("input[name='delivery']").data().source_country;

                source = source.toLowerCase() == "Italia".toLowerCase() ? "Italy" : source;
                source = source.toLowerCase() == "Francia".toLowerCase() ? "France" : source;
                source = source.toLowerCase() == "Belgio".toLowerCase() ? "Belgium" : source;
                source = source.toLowerCase() == "Lettonia".toLowerCase() ? "Latva" : source;
                source = source.toLowerCase() == "Lituania".toLowerCase() ? "Lithuania" : source;
                source = source.toLowerCase() == "Croazia".toLowerCase() ? "Croatia" : source;
                source = source.toLowerCase() == "Lussemburgo".toLowerCase() ? "Luxembourg" : source;
                source = source.toLowerCase() == "Cipro".toLowerCase() ? "Cyprus" : source;
                source = source.toLowerCase() == "Olanda".toLowerCase() ? "Netherlands" : source;
                source = source.toLowerCase() == "Danimarca".toLowerCase() ? "Denmark" : source;
                source = source.toLowerCase() == "Polonia".toLowerCase() ? "Poland" : source;
                source = source.toLowerCase() == "Portogallo".toLowerCase() ? "Portugal" : source;
                source = source.toLowerCase() == "Finlandia".toLowerCase() ? "Finland" : source;
                source = source.toLowerCase() == "Slovacchia".toLowerCase() ? "Slovakia" : source;
                source = source.toLowerCase() == "Germania".toLowerCase() ? "Germany" : source;
                source = source.toLowerCase() == "Grecia".toLowerCase() ? "Greece" : source;
                source = source.toLowerCase() == "Spagna".toLowerCase() ? "Spain" : source;
                source = source.toLowerCase() == "Ungheria".toLowerCase() ? "Hungary" : source;
                source = source.toLowerCase() == "Svezia".toLowerCase() ? "Sweden" : source;
                source = source.toLowerCase() == "Irlanda".toLowerCase() ? "Ireland" : source;

                console.log(destination, source);

                if (destination == source && $('#tier_italy').data('amount') !== undefined) {
                    console.log("A");
                    $('#shipping_amount_container').text('€ ' + $('#tier_italy').data('amount'))
                } else if ($('select[name=\'shipping_address\'] option:selected').data('iseu') == '1' && $('#tier_italy').data('amount') !== undefined) {
                    console.log("B");
                    $('#shipping_amount_container').text('€ ' + $('#tier_eu').data('amount'))
                } else {
                    $('#custom_quotation').removeClass('hide')
                    $('.make_an_offer, .add_to_cart').addClass('hide')
                    console.log("C");
                }

            }


            if ($('.self_shipment_area').length > 0) {
                $('.self_shipment_area').each((index, area) => {
                    area = $(area)
                    let selfShipmentAvailalbeAddresses = area.data().availableshippingaddresses
                    if (selfShipmentAvailalbeAddresses.includes(parseInt(shippingObject.val()))) {

                        //$('#shipping_amount_container').text('€ ' + area.data('amount'))
                        area.removeClass('hide')
                    }
                })
            }

            if ($('select[name=\'shipping_address\'] option:selected').data('country') == 'Italy') {
                // console.log("A");
                // $("#tier_italy").removeClass("hide");
            } else if ($('select[name=\'shipping_address\'] option:selected').data('iseu') == '1') {
                // console.log("B");
                // $("#tier_eu").removeClass("hide");
            } else {
                //  console.log("C");
                // $("#custom_quotation").removeClass("hide");
            }

            // if (externalQuotation != null && externalQuotation < $("#tier_italy").data("amount")) {
            //     $("#external_quotation").removeClass("hide");
            //     $("#external_quotation_amount").text(externalQuotation);
            // } else {

            //     if ($("select[name='shipping_address'] option:selected").data("country") == "Italy") {
            //         $("#tier_italy").removeClass("hide");
            //     } else if ($("select[name='shipping_address'] option:selected").data("iseu") == "1") {

            //         $("#tier_eu").removeClass("hide");
            //     } else {

            //         $("#custom_quotation").removeClass("hide");
            //     }
            // }

            //console.log(shippingObject.val(), shippingObject.data().product_id);
        })
    }

    const offerButton = $('*[data-make_offer]').first()
    if (offerButton.length) {
        $('*[data-make_offer]').click((evt) => {
            if (!platformEnvironmentVars.isLogged) {
                const modalRegister = $('#modal_register')
                modalRegister.find('#continue_as_guest').addClass('hide')
                if (modalRegister) $(modalRegister).foundation('open')
                return
            }
            let button = $(evt.target)
            if ($('input[name=\'delivery\']:checked').val() === undefined) {
                swal(
                    'Attention',
                    translations.select_at_least_a_delivery_method,
                    'warning'
                )
                return
            }
            if (
                $('input[name=\'delivery\']:checked').val().indexOf('delivery') >=
                0 &&
                $('select[name=\'shipping_address\']').val() === undefined
            ) {
                swal(
                    'Attention',
                    'Please, Select a shipping address',
                    'warning'
                )
                return
            }
            // if ($("input[name='delivery']:checked").val().indexOf("pickup") === -1 && $("select[name='shipping_address']").length > 0 && !$("select[name='shipping_address'] option:selected").data("country").toLowerCase().startsWith("ita")) {
            //   swal('Attention', 'The shipping selected is available only for shippings to Italy', 'warning');
            //   return;
            // }

            $('#modal_make_offer input#shipping_amount').val(
                $('input[name=\'delivery\']:checked').val()
            )
            $('#modal_make_offer input#shipping_to_address').val(
                $('select[name=\'shipping_address\']').val()
            )
            $('#modal_make_offer input#shipping_group').val(
                $('input[name=\'delivery\']:checked').data('group')
            )
            $('#modal_make_offer input#quantity').val(
                $('select[name=\'quantity\']').val()
            )
            $('#modal_make_offer').foundation('toggle')
        })
    }

    const deleteProductButton = $('*[data-delete_product]').first()
    if (deleteProductButton.length) {
        $('*[data-delete_product]').click((evt) => {
            waitConfirmation((cb) => {
                let button = $(evt.target)
                $.ajax({
                    url: button.data().action_url,
                    data: { _method: 'delete' },
                    method: 'POST',
                    dataType: 'JSON',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr(
                            'content'
                        ),
                    },
                    success: function (data) {
                        location.href = data.return_url
                    },
                })
            })
        })
    }

    const customQuotationButton = $('*[data-ask_custom_quotation]').first()
    if (customQuotationButton.length) {
        $(customQuotationButton).click((evt) => {
            let button = $(evt.target)

            if (!platformEnvironmentVars.isLogged) {
                const modalRegister = $('#modal_register')
                modalRegister.find('#continue_as_guest').removeClass('hide')
                let requestFields = $('#proceed-as-guest-trigger').data(
                    'request_fields'
                )
                requestFields = requestFields.replace(/\\/g, '\\\\')
                requestFields = JSON.parse(requestFields)
                requestFields.custom_quotation = 'true'
                $('#proceed-as-guest-trigger').attr(
                    'data-request_fields',
                    JSON.stringify(requestFields)
                )

                $(modalRegister).on('closed.zf.reveal', function () {
                    var modal = $(this)
                    document.getElementById('ask_quotation').checked = false
                    let requestFields = $('#proceed-as-guest-trigger').data(
                        'request_fields'
                    )
                    requestFields = requestFields.replace(/\\/g, '\\\\')
                    requestFields = JSON.parse(requestFields)
                    delete requestFields.custom_quotation
                    $('#proceed-as-guest-trigger').attr(
                        'data-request_fields',
                        JSON.stringify(requestFields)
                    )
                })

                if (modalRegister) $(modalRegister).foundation('open')
                return
            }

            if ($('select[name=\'shipping_address\']').val() === '') {
                swal(
                    'Attention',
                    'Please, Select a shipping address',
                    'warning'
                )
                document.getElementById('ask_quotation').checked = false
                return
            }

            let actionUrl = button.data('action_url')
            let parameters = {}
            parameters.quantity = $('*[data-quantity]').first().length
                ? $('*[data-quantity]').first().val()
                : 1
            parameters.shipping = 'delivery'
            parameters.shipping_address = $(
                'select[name=\'shipping_address\']'
            ).val()
            parameters.custom_quotation = true
            let cart = new Cart()
            cart._handleItem(actionUrl, parameters)
            return
        })
    }

    const selects2 = $(".select2")
    if (selects2.length) {
        selects2.each(function () {
            let item = $(this)
            item.select2({
                matcher: function (params, data) {
                    if ($.trim(params.term) === '') {
                        return data;
                    }
                    var keywords = (params.term).split(" ");
                    for (var i = 0; i < keywords.length; i++) {
                        if (((data.text).toUpperCase()).indexOf((keywords[i]).toUpperCase()) == -1)
                            return null;
                    }
                    return data;
                }
            })
        })
    }

    const productTags = $('*[data-input_type=tags]')
    if (productTags.length) {
        productTags.each(function () {
            let item = $(this)
            item.select2({
                tags: true,
            })
        })
    }

    // const confiramtionLinks = $("*[data-link_wait_confirm]")
    // if (confiramtionLinks.length) {
    //   confiramtionLinks.each(() => {
    //     console.log("found");
    //     $(this).click((event) => {
    //       console.log(event);
    //       event.preventDefault();
    //       waitConfirmation(cb => {
    //         location.reload();
    //       });
    //     });
    //   });
    // }

    $('*[data-link_wait_confirm]').click((event) => {
        event.preventDefault()
        let target = $(event.target).attr('href')
        waitConfirmation((cb) => {
            location.href = target
        })
    })
    const productPrice = $('*[data-source_price_income]')
    if (productPrice.length) {
        $('*[data-source_price_income]').first().change()
        $(productPrice).change((evt) => {
            let income =
                $(evt.target).val() -
                ($(evt.target).val() / 100) * sellerFeeAmount
            $('*[data-target_price_income]').first().val(income)
        })
    }

    const productDiscountPrice = $('*[data-source_discount_price_income]')
    if (productDiscountPrice.length) {
        $(productDiscountPrice).change((evt) => {
            let income =
                $(evt.target).val() -
                ($(evt.target).val() / 100) * sellerFeeAmount
            $('*[data-target_discount_price_income]').first().val(income)
        })
    }

    const productResevePrice = $('*[data-source_reserve_price_income]')
    if (productResevePrice.length) {
        $(productResevePrice).change((evt) => {
            let income =
                $(evt.target).val() -
                ($(evt.target).val() / 100) * sellerFeeAmount
            $('*[data-target_reserve_price_income]').first().val(income)
        })
    }

    const rejectProduct = $('*[data-reject_product]')
    if (rejectProduct.length) {
        $(rejectProduct).click((evt) => {
            const modalReject = $('#modal_reject_product')
            if (modalReject) $(modalReject).foundation('open')
        })
        //return;
    }

    // limited lists
    const limitedList = $('*[data-limited-list]')
    if (limitedList.length) {
        let lists = new LimitedList(limitedList)
        //console.log(lists);
    }

    const editableOverlay = $('*[data-editable-overlay]')
    if (editableOverlay.length) {
        editableOverlay.each((index, el) => {
            $(el).click((event) => {
                if ($(el).data('requires_login') !== 'undefined' && $(el).data('requires_login')) {
                    if (!platformEnvironmentVars.isLogged) {
                        const modalRegister = $('#modal_register')
                        modalRegister.find('#continue_as_guest').addClass('hide')
                        if (modalRegister) $(modalRegister).foundation('open')
                        return
                    }
                }
                let requestData = '{}'
                if (typeof $(el).data('request_fields') !== 'undefined') {
                    requestData = $(el).attr('data-request_fields').replace(/\\/g, '\\\\')
                }
                requestData = requestData.replace(/\\\\/g, '\\')
                if (requestData.indexOf('\\\\') < 0) {
                    requestData = requestData.replace(/\\/g, '\\\\')
                }
                //console.log(JSON.parse(requestData));
                $.ajax({
                    url: $(el).data('action-url'),
                    data: JSON.parse(requestData),
                    success: function (data) {
                        $($(el).data('editable-html-target')).html(data)
                        $($(el).data('editable-html-target')).foundation(
                            'open'
                        )
                    },
                })
            })
        })
    }

    function sendFormAjax(form) {
        let ajaxObject = {
            url: form.attr("action"),
            data: form.serialize(),
            method: form.attr("method"),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr(
                    'content'
                ),
            },
            success: function (data) {
                // Do nothing,
            },
        }

        $.ajax(ajaxObject)
    }

    $('#container-profile-config [data-tabs-target]').on('click', function (event) {
        let previous = $(event.target).closest('#container-profile-config').find('.tabs-title.is-active')

        let form = $('#' + previous.find('[data-tabs-target]').attr('data-tabs-target')).find("form").first()

        form.length && sendFormAjax(form);
    })


    function setConversationAsReadFromForm(target) {

        target.find('.notify').remove();

        let form = $('#' + target.attr('data-tabs-target')).find("form").first()

        form.length && sendFormAjax(form);
    }

    $('#container-conversation [data-tabs-target]').on('click', function (event) {
        let target = $(event.target).closest('[data-tabs-target]');
        setConversationAsReadFromForm(target);

    })

    // remove notification immediately for first selected
    let target = $('#container-conversation .tabs-title.is-active [data-tabs-target]');

    if (target) {
        setConversationAsReadFromForm(target);
    }

    const ajaxActionOnSubmit = $('*[data-ajax-submit]')

    if (ajaxActionOnSubmit.length) {
        ajaxActionOnSubmit.each((index, el) => {
            $(el).on("click", function ($event) {
                let el = $($event.target);
                let form = el.closest("form");

                sendFormAjax(form);
            })
        })
    }

    window.listenerDataAction = function () {
        const ajaxAction = $('*[data-ajax-action]')
        if (ajaxAction.length) {
            ajaxAction.each((index, el) => {
                let requestData = {}
                if (typeof $(el).data('request_fields') !== 'undefined') {
                    requestData = JSON.parse(
                        $(el).data('request_fields').replace(/\\/g, '\\\\')
                    )
                }

                let method = 'post'
                if (typeof $(el).data('method-url') !== 'undefined') {
                    method = $(el).data('method-url')
                    requestData._method = method
                }

                let ajaxObject = {
                    url: $(el).data('action-url'),
                    data: requestData,
                    method: 'post',
                    dataType: 'JSON',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr(
                            'content'
                        ),
                    },
                    success: function (data) {
                        if (data.response.action == 'reload') {
                            if (typeof data.response.hash) {
                                window.location.hash = data.response.hash
                            }
                            location.reload()
                        } else if (data.response.action == 'message') {
                            const wrapper = document.createElement('div')
                            wrapper.innerHTML = data.response.messageTitle
                            swal({
                                title: 'Attention',
                                text: '',
                                content: wrapper,
                            })
                        } else if (data.response.action == 'success') {
                            const wrapper = document.createElement('div')
                            swal({
                                title: data.response.messageTitle,
                                text: data.response.messageText,
                                content: wrapper,
                            })
                        } else if (data.response.action == 'redirect') {
                            location.href = data.response.location
                        } else {
                            location.reload()
                        }

                        if ($(el).data('callback')) {
                            window[$(el).data('callback')]($(el), data.response);
                        }
                    },
                }

                $(el).click((event) => {
                    if (
                        typeof $(el).data('request-function-fields') !== 'undefined'
                    ) {
                        const keys = Object.keys(
                            $(el).data('request-function-fields')
                        )
                        for (let key of keys) {
                            requestData[key] = eval(
                                $(el).data('request-function-fields')[key]
                            )
                        }
                    }

                    if (
                        typeof $(el).data('await-confirmation') === 'undefined' ||
                        $(el).data('await-confirmation')
                    ) {
                        waitConfirmation((cb) => {
                            $.ajax(ajaxObject)
                        })
                    } else {
                        $.ajax(ajaxObject)
                    }
                })
            })
        }

    }

    window.listenerDataAction();

    function waitConfirmation(callback) {
        swal({
            title: 'Are you sure?',
            text: '',
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                callback()
            }
        })
    }

    // const tooltips = $("*[data-tooltip]");
    // if (tooltips.length) {
    //   tooltips.each((index, el) => {
    //     tippy('#sellButton', {
    //       content: "here i am!",
    //     })
    //   })
    // }

    // if ($('#product-form').length > 0) {
    //   $('#product-form').on('keyup change paste', 'input, select, textarea', function(){
    //       // console.log('Form changed!');
    //       $("#product-form .c-user-addresses__list__item__actions button, #add-pickup-address-button").each(function() {
    //         var item = $(this);
    //         item.unbind("click");
    //         item.attr("style", "background-color: #ccc; color: white");
    //         item.removeAttr("data-editable-html-target").removeAttr("data-editable-overlay").removeAttr("data-action-url");
    //         item.attr("onClick", "event.preventDefault(); swal('Attention', 'Please, save the product before handling the pickup address.', 'warning');");
    //       });
    //       //$("#product-form .c-user-addresses__list__item__actions")

    //   });
    // }

    document.addEventListener('wheel', function (event) {
        if (document.activeElement.type === 'number') {
            document.activeElement.blur()
        }
    })

    /*if ($('#product-form').length) {
        $('#product-form :input').change(() => {
            $(
                '.edit-pickup-address-button, .delete-pickup-address-button, #add-pickup-address-button'
            ).each((index, el) => {
                $(el).attr('disabled', 'disabled').removeAttr('data-editable-overlay').removeAttr('data-editable-html-target').removeAttr('data-action-url')
                $(el).click(() => {
                    swal('Please, save product first')
                })
                //$(el).removeAttr("data-ajax-action").removeAttr("data-method-url").removeAttr("data-action-url");
            })

            //$("#add-pickup-address-button")
        })
    }*/

    if ($('.upload-invoice-trigger').length) {
        $('.upload-invoice-trigger').change((event) => {
            console.log($(event.target).parent().submit())
        })
    }

    tippy('*[data-tippy-content]')

    const notifications = $('*[data-notifications]')

    if (notifications.length) {
        notifications.each((index, el) => {
            const wrapper = document.createElement('div')
            wrapper.innerHTML = $(el).data('message')
            if ($(el).data('action') != '') {
                wrapper.innerHTML += '<br><br><a href=\'' + $(el).data('action') + '\'>' + $(el).data('action_label') + '</a>'
            }
            // console.log(wrapper)
            swal({
                icon: $(el).data('type_notification'),
                title: $(el).data('subject'),
                text: '',
                content: wrapper,
            })
        })
    }

    // checkbox

    function removeParam(key, sourceURL) {
        var rtn = sourceURL.split('?')[0],
            param,
            params_arr = [],
            queryString =
                sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : ''
        if (queryString !== '') {
            params_arr = queryString.split('&')
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split('=')[0]
                if (param === key) {
                    params_arr.splice(i, 1)
                }
            }
            rtn = rtn + '?' + params_arr.join('&')
        }
        return rtn
    }

    if ($('#italy').length) {
        $('#italy').on('click', function () {
            if ($('#italy').hasClass('is-active')) {
                $('#italy_regions').hide()
            } else {
                $('#italy_regions').show()
            }
        })
    }

    if ($('#datepicker').length) {
        var isSetSelectedValue = false
        var availabeDates = Object.values(
            $('#datepicker').data('enabled-dates')[0]
        )
        var datepicker = $('#datepicker').datepicker({
            clearButton: true,
            onRenderCell: function onRenderCell(date, cellType) {
                return {
                    disabled: !availabeDates.includes(formatDate(date)),
                }
            },
            onSelect: function onSelect(fd, date) {
                var date = new Date(date)
                if (!isNaN(date)) {
                    var month = date.getMonth() + 1
                    var day = date.getDate()
                    month = (month < 10 ? '0' : '') + month
                    day = (day < 10 ? '0' : '') + day
                    var formatedDate = date.getFullYear() + month + day
                    var newQueryString = location.search.replace(
                        /&by_date=\d+|\?by_date=\d+/,
                        ''
                    )
                    if (isSetSelectedValue) {
                        if (newQueryString.indexOf('?') > -1) {
                            window.location.href =
                                newQueryString + '&by_date=' + formatedDate
                        } else {
                            window.location.href =
                                newQueryString + '?by_date=' + formatedDate
                        }
                    }
                }
            },
        }).data('datepicker')
        $('.datepicker--buttons').on('click', function () {
            removeParam('by_date')
        })

        function formatDate(date) {
            var date = new Date(date)
            var month = date.getMonth() + 1
            var day = date.getDate()
            month = (month < 10 ? '0' : '') + month
            day = (day < 10 ? '0' : '') + day
            var formatedDate = date.getFullYear() + month + day

            return formatedDate
        }

        function removeParam(key) {
            var url = document.location.href
            var params = url.split('?')
            if (params.length == 1) return

            url = params[0] + '?'
            params = params[1]
            params = params.split('&')

            $.each(params, function (index, value) {
                var v = value.split('=')
                if (v[0] != key) url += value + '&'
            })

            url = url.replace(/&$/, '')
            url = url.replace(/\?$/, '')

            document.location.href = url
        }

        const queryString = window.location.search
        const paramDate = new URLSearchParams(queryString).get('by_date')
        if (paramDate && paramDate.length == 8) {
            datepicker.selectDate(
                new Date(
                    +paramDate.substring(0, 4),
                    +paramDate.substring(4, 6) - 1,
                    +paramDate.substring(6, 8)
                )
            )
            isSetSelectedValue = true
        } else {
            isSetSelectedValue = true
        }
    }
    /// calendar
    if ($('.datepicker--cell-day').length) {
        var cw = $('.datepicker--cell-day').width()
        var mw = (+$('.datepicker').width() - 32) / 2
        var yw = (+$('.datepicker').width() - 42) / 3
        $('.datepicker--cell-day').css({ height: cw + 'px' })
        $('.datepicker--cell-month').css({ width: mw.toString() + 'px' })
        $('.datepicker--cell-year').css({ width: yw.toString() + 'px' })

        $('.datepicker--days-names').css({ height: cw + 'px' })

        $('body').on('click', function () {
            var cw = $('.datepicker--cell-day').width()
            var mw = (+$('.datepicker').width() - 32) / 2
            var yw = (+$('.datepicker').width() - 42) / 3

            $('.datepicker--cell-day').css({ height: cw + 'px' })
            $('.datepicker--cell-month').css({ width: mw.toString() + 'px' })
            $('.datepicker--cell-year').css({ width: yw.toString() + 'px' })

            $('.datepicker--days-names').css({ height: cw + 'px' })
        })
    }

    $('.podcast-text-description a').on('click', function (e) {
        var $element = $('.podcast-text-description .text-wrapper')
        e.preventDefault()
        if ($element.css('display') === 'none') {
            $element.slideDown()
        } else {
            $element.slideUp()
        }
        return false
    })


    $('.add-field-button').click(function (event) {
        var countTextInputs = $('.fields-container input[type="text"]').length
        let titleItem = $('#label-link').text();
        let titlePrice = $(`label[for="item-price"]`).first().text();
        console.log($(`label[for="item-price"]`));
        let titlePriceIncome = $(`label[for="item-price-income-0"]`).text();

        $(event.target).parent().find('.fields-container').append(`<label id="label-link">${titleItem}</label><input type="text" class="" placeholder="" name="links[${countTextInputs}][link]" value="" />
            <div">
                <div class="grid-x grid-margin-x">
                    <div class="cell medium-6">
                        <div>
            <label for="item-price">${titlePrice}</label>
            <div class="input-group">
                <input type="number" class="input-group-field item-price" name="links[${countTextInputs}][price]" id="links[${countTextInputs}][price]" placeholder="0 €" value="" pattern="number" data-source_price_income="true" data-item="${countTextInputs}" data-np-intersection-state="visible">
                 </div>
            </div>
                                </div>
                                <div class="cell medium-6">
                                    <div>
    <label for="item-price-income-${countTextInputs}">${titlePriceIncome}</label>
    <div class="input-group">
        <input type="number" class="input-group-field item-price-income-${countTextInputs}" name="price_your_income" id="price_your_income" placeholder="0 €" value="" pattern="number" disabled="" data-target_price_income="true">
            </div>
    </div>
                                </div>
                            </div>
                        </div>`)
    })


    $(".nation-field-holder").change(function ($event) {

        let country = $event.target.value;


        let target = $('.vat-field-holder');


        let prefix = $($event.target).attr("[_required]") ? "_" : "";

        if (countries.includes(country)) {
            target.attr(prefix + "required", "");
        } else {
            target.removeAttr(prefix + "required");
        }
    })


    $('#billink_bank_iban').on('input', function (evt) {
        var IBAN = require('iban');

        $(evt.target).val($(evt.target).val().toUpperCase())

        const isValid = IBAN.isValid($(evt.target).val());
        evt.target.setCustomValidity(isValid ? "" : "Invalid IBAN");

    })
})

window.refreshFavColor = function (container, message) {

    container.attr('data-is-favorite', parseInt(container.attr('data-is-favorite')) == 1 ? 0 : 1);
}



window.handlePaginationUrl = function(pageName, currentLocation, newPage, hash) {
    var params = new URLSearchParams(currentLocation.search);
    params.set(pageName, newPage);

    if (hash) {
      window.location.hash = hash;
    }
    console.log("AAA", params.toString());
    window.location.search = decodeURIComponent(params.toString());
}
